import styled from 'styled-components'
import { FlexRow } from '@src/styles'

export const LabelGroup = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: -20px;
`
export const LabelButton = styled.label`
  cursor: pointer;
  margin-right: 20px;
  color: ${props => props.theme.white};
  opacity: 1;
  svg {
    fill: ${props => props.theme.white};
    height: 16px;
  }
`
export const DropDiv = styled<any>(FlexRow)`
  cursor: pointer;
  color: ${props => props.theme.white};
  opacity: 1;
`

export const Paragraph = styled.p`
  color: ${props => props.theme.white};
  text-align: left;
  font-size: 0.9em;
  border-bottom: ${props => props.theme.gray};
  span, a {
    font-weight: bold;
    font-family: NunitoSansBold;
  }
`

export const BtnCont = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const IntroModal = styled.div`
  p {
    margin-top: 0;
  }
  ul {
    padding: 0;
  }
  li {
    list-style-type: none;
    text-align: left;
    display: flex;
    align-items: center;
    margin: 10px 0;
    font-size: 0.9em;
    svg {
      margin-right: 5px;
    }
  }
`

export const ChecklistPanel = styled.div`
  border: 1px solid ${props => props.theme.gray};
  border-radius: 8px;
  margin: 16px 0;
  background: ${props => props.theme.listBack || props.theme.cardBackground || 'transparent'};
  overflow: hidden;
`

export const ChecklistHeader = styled<any>(FlexRow)`
  cursor: pointer;
  padding: 12px 16px;
  justify-content: space-between;
  align-items: center;
  user-select: none;
  &:hover {
    background: ${props => props.theme.buttonHover || 'rgba(255,255,255,0.05)'};
  }
  .checklist-title {
    font-size: 0.95em;
    font-weight: 600;
    font-family: NunitoSansSemiBold;
    color: ${props => props.theme.white};
  }
  .checklist-progress-text {
    font-size: 0.8em;
    color: ${props => props.theme.textSecondary || props.theme.white};
    opacity: 0.7;
    margin-left: 12px;
  }
  .checklist-chevron {
    transition: transform 0.2s ease;
    fill: ${props => props.theme.white};
    width: 16px;
    height: 16px;
    &.expanded {
      transform: rotate(180deg);
    }
  }
`

export const ChecklistProgress = styled.div<{ percentage: number }>`
  height: 3px;
  background: ${props => props.theme.gray || 'rgba(255,255,255,0.1)'};
  .bar {
    height: 100%;
    width: ${props => props.percentage}%;
    background: ${props => props.theme.accent || '#33AA40'};
    transition: width 0.3s ease;
  }
`

export const ChecklistBody = styled.div<{ expanded: boolean }>`
  max-height: ${props => props.expanded ? '600px' : '0'};
  overflow: hidden;
  transition: max-height 0.3s ease;
  padding: ${props => props.expanded ? '0 16px 12px' : '0 16px'};
`

export const ChecklistItemRow = styled.div<{ suggested?: boolean }>`
  display: flex;
  align-items: center;
  padding: 8px 0;
  font-size: 0.9em;
  color: ${props => props.theme.white};
  border-bottom: 1px solid ${props => props.theme.gray || 'rgba(255,255,255,0.06)'};
  ${props => props.suggested ? `
    background: rgba(51, 170, 64, 0.08);
    border-radius: 4px;
    padding: 8px 6px;
    margin: 2px -6px;
  ` : ''}
  &:last-child {
    border-bottom: none;
  }
  input[type="checkbox"] {
    margin-right: 10px;
    cursor: pointer;
    width: 16px;
    height: 16px;
    accent-color: ${props => props.theme.accent || '#33AA40'};
  }
  input[type="checkbox"]:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
  .item-label {
    flex: 1;
  }
  .suggested-badge {
    font-size: 0.75em;
    color: ${props => props.theme.accent || '#33AA40'};
    margin-left: 8px;
    font-style: italic;
  }
  .drive-link-button {
    background: transparent;
    border: 1px solid ${props => props.theme.accent || '#33AA40'};
    border-radius: 4px;
    color: ${props => props.theme.accent || '#33AA40'};
    cursor: pointer;
    font-size: 0.75em;
    margin-left: 10px;
    padding: 4px 8px;
    white-space: nowrap;
  }
`
